



























import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import permissionGuard from '@/guards/permission-guard';
import { SmartQuery } from 'vue-apollo-decorator';
import { UNIT_PAYCHECK_SETTINGS } from '@/queries/CompanySetting';
import { GQL_unitPaycheckSetting_currentUnit } from '@/queries/__generated__/unitPaycheckSetting';
import {
  GQL_vacationMoneyReport,
  GQL_vacationMoneyReportVariables,
  GQL_vacationMoneyReport_vacationMoneyReport,
} from '@/queries/__generated__/vacationMoneyReport';
import {
  GQL_settingsVacationMoneyReport,
  GQL_settingsVacationMoneyReportVariables,
  GQL_settingsVacationMoneyReport_settingsVacationMoneyReport,
} from '@/queries/__generated__/settingsVacationMoneyReport';
import DocumentLogo from '@/components/Invoicing/Shared/DocumentLogo.vue';
import LeftToPaySummary from './LeftToPaySummary.vue';
import { VACATION_MONEY_REPORT, VACATION_MONEY_REPORT_SETTINGS } from './queries';

@Component({
  components: {
    DocumentLogo,
    LeftToPaySummary,
  },
  beforeRouteEnter(to, from, next) {
    permissionGuard('canCreatePaychecks', to, from, next)
      .catch(router => {
        router.push({ name: 'Dashboard' });
        router.app.$sMessage.error(router.app.$t('noPermissions'));
      });
  },
})
export default class VacationMoneyReportPdf extends Vue {
  @Prop({ type: Number, required: true }) private year!: number;

  @SmartQuery(UNIT_PAYCHECK_SETTINGS) private currentUnit?: GQL_unitPaycheckSetting_currentUnit;

  @SmartQuery<VacationMoneyReportPdf, GQL_settingsVacationMoneyReport, GQL_settingsVacationMoneyReportVariables>({
    query: VACATION_MONEY_REPORT_SETTINGS,
    skip() { return !this.currentUnit },
    variables() {
      return { unitId: this.currentUnit!.id, year: this.year };
    },
    fetchPolicy: 'no-cache',
    update: data => data.settingsVacationMoneyReport,
  }) private settings?: GQL_settingsVacationMoneyReport_settingsVacationMoneyReport;

  // Waits for the settings, as they are created on first fetch
  // and the report depends on them.
  @SmartQuery<VacationMoneyReportPdf, GQL_vacationMoneyReport, GQL_vacationMoneyReportVariables>({
    query: VACATION_MONEY_REPORT,
    skip() { return !this.currentUnit || !this.settings },
    variables() {
      return { unitId: this.currentUnit!.id, year: this.year };
    },
    fetchPolicy: 'no-cache',
    update: data => data.vacationMoneyReport,
  }) private reportData?: GQL_vacationMoneyReport_vacationMoneyReport[];

  @Provide() private isPdf = true;
}
